import { Component } from 'react'
import './Popover.css'
import { Popover } from 'antd'

/** Usage: https://ant.design/components/popover/ */
export default class YPopover extends Component {
  render () {
    const { hide, children, ...restProps } = this.props
    if (hide) {
      return children
    }
    return (
      <Popover
        {...restProps}
      >
        {children}
      </Popover>
    )
  }
}

YPopover.defaultProps = {
  overlayClassName: 'y-popover',
  placement: 'top',
  trigger: 'hover',
  mouseEnterDelay: 0.1,
  mouseLeaveDelay: 0.1,
  overlayStyle: {}
}
